<template>
  <v-container class="page fill-height">
    <Toolbar
      :title="agreement && $vuetify.breakpoint.xsOnly ? agreement.servicePlan.name : null"
      :loading="isLoading && !!agreement"
    />
    <template v-if="error">
      <PageNotFoundError v-if="'Not Found' === error" />
      <GenericError v-else />
    </template>

    <div v-else-if="isLoading" class="content-spinner">
      <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
    </div>
    <template v-if="agreement">
      <PageNotFound v-if="!agreement.startsAt" />
      <AgreementManage v-else :agreement="agreement" @reload="reload" />
    </template>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Toolbar from '@/components/Toolbar.vue'
import { mapActions, mapGetters } from 'vuex'
import AgreementManage from '@/components/AgreementManage/AgreementManage'
import PageNotFoundError from 'usail-vue-sdk/components/error/PageNotFound'
import GenericError from 'usail-vue-sdk/components/error/GenericError'
import PageNotFound from '@/views/error/PageNotFound'

export default {
  name: 'AgreementShow',
  components: {
    PageNotFound,
    AgreementManage,
    Toolbar,
    PageNotFoundError,
    GenericError
  },
  computed: {
    ...mapGetters({
      error: 'connectagreement/show/error',
      agreement: 'connectagreement/show/retrieved',
      isLoading: 'connectagreement/show/isLoading'
    })
  },

  beforeDestroy() {
    this.reset()
  },

  beforeRouteUpdate(to, from, next) {
    this.reset()
    next()
  },

  mounted() {
    this.fetchAgreement()
  },

  methods: {
    ...mapActions({
      getAgreements: 'connectagreement/list/default',
      getAgreement: 'connectagreement/show/retrieve',
      reset: 'connectagreement/show/reset'
    }),

    reload() {
      this.fetchAgreement()
      this.getAgreements('/connect_agreements?pagination=false&archived=false')
    },

    fetchAgreement() {
      this.getAgreement(decodeURIComponent('/connect_agreements/' + this.$route.params.id) + '?stripe=true')
    }
  }
}
</script>
